const formatUrl = (baseUrl: string, path: string, queries?: Record<string, string>): string => {
  const url = new URL(path, baseUrl);
  let search = '';
  if (queries) {
    // TypeScript >= 3.2 will accept the below code.
    // const searchParams = new URLSearchParams(queries);
    const searchParams = new URLSearchParams();
    Object.keys(queries).forEach((key) => searchParams.append(key, queries[key]));
    search = `?${searchParams.toString()}`;
  }

  return url.href + search;
};

export default formatUrl;
